








import { Vue, Component } from 'vue-property-decorator'

@Component
export default class extends Vue {
  get errors() {
    const array: Array<[string, string]> = []
    const errors = parseErrorString(this.$route.query.error as string)
    for (const attr of Object.keys(errors)) {
      const es = errors[attr]
      for (const e of es) {
        array.push([attr, e])
      }
    }
    return array
  }

  close() {
    this.$router.push('/')
  }
}

function parseErrorString(q: string): { [attribute: string]: string[] } {
  try {
    const errors = JSON.parse(q)
    return typeof errors === 'object' ? errors : []
  } catch {
    return {}
  }
}
